import type { GardenUpdatePayload } from "@/types/garden";
import type { ScorerSelection } from "@/types";
import Repository from "./repository";

const resource = "/gardens";

export default {
  getAll() {
    return Repository.get(`${resource}/`);
  },
  // TODO: This function is not used, create a GardenCreatePayload if needed
  create(data: GardenUpdatePayload) {
    return Repository.post(`${resource}/`, data);
  },
  patch(gardenId: number, data: GardenUpdatePayload) {
    return Repository.patch(`${resource}/${gardenId}/`, data);
  },
  getScorerPreferences(gardenId: number) {
    return Repository.get(`${resource}/${gardenId}/scorer_preferences/`);
  },
  // Persist the garden's scorer preferences WITHOUT launching an optimisation (used by the
  // standalone editor; the suggestions + optimiser both read the saved prefs). The body is a
  // raw JSON array of selections; returns the full updated list (same shape as GET).
  saveScorerPreferences(gardenId: number, scorers: ScorerSelection[]) {
    return Repository.patch(`${resource}/${gardenId}/scorer_preferences/`, scorers);
  },
  // Surface occupied by crops over a month window vs. the available surface, with
  // the peak highlighted. `start_month`/`end_month` are "YYYY-MM" (required).
  getSurfaceUsage(gardenId: number, startMonth: string, endMonth: string) {
    return Repository.get(`${resource}/${gardenId}/surface_usage/`, {
      params: { start_month: startMonth, end_month: endMonth },
    });
  },
  // `scorers` are saved (upsert) then the optimisation is launched. Omitting them
  // keeps the garden's saved preferences unchanged (backward-compatible).
  // `months` (start_month/end_month, "YYYY-MM") bounds the cultivation window.
  optimize(gardenId: number, scorers?: ScorerSelection[], months?: { start_month: string; end_month: string }) {
    const payload: { scorers?: ScorerSelection[]; start_month?: string; end_month?: string } = {};
    if (scorers) payload.scorers = scorers;
    if (months) {
      payload.start_month = months.start_month;
      payload.end_month = months.end_month;
    }
    return Repository.post(`${resource}/${gardenId}/optimize/`, payload);
  },
};
